import React from 'react'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import bgServices from '../assets/images/bgServices.jpg'
import Footer from '../components/Footer'

const Service = () => {
    return (
        <div>
            <Navbar />
            <Hero
                cName="hero"
                heroImg={bgServices}
                headingText="Embark on Educational Adventures: Experience the World with Our VR Travel Learning Platform"
                paraText="Welcome to our Virtual Reality Educational Tour Service! Immerse yourself in captivating virtual experiences that combine the thrill of exploration with the depth of educational content. Our VR app transports you to fascinating locations around the world, providing an interactive learning journey like no other."
                url="/"
                linkText="Know more" />
            <Footer />
        </div>
    )
}

export default Service
